import { render, staticRenderFns } from "./Provisions.vue?vue&type=template&id=0734774a&"
import script from "./Provisions.vue?vue&type=script&lang=js&"
export * from "./Provisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports